<div class="ds-table" [ngClass]="tableClasses">
  <ds-table-header [columns]="columns" [style.height.px]="headerHeight"></ds-table-header>
  <ds-table-body
    [rows]="rows"
    [columns]="columns"
    [rowDetail]="rowDetail"
    [tableClasses]="tableClasses"
  ></ds-table-body>
</div>
